import { InjectionToken } from '@angular/core';

/** News feed API url injection token */
export const BRAND_ORGS_API_TOKEN = new InjectionToken<string>(
  'Brand Orgs API url',
);
